module.exports = __webpack_public_path__ + "static/media/starts_with_v.0f3243da.mp3";